import { now } from 'owa-datetime';
export function getExpiredSharingData(sharingData) {
    return sharingData.filter(function (x) { return isSharingDataExpired(x); });
}
export function isSharingDataExpired(sharingData) {
    return (sharingData &&
        sharingData.sharingInfo &&
        !!sharingData.sharingInfo.expirationDate &&
        !sharingData.sharingInfo.ignoreExpirationDate &&
        new Date(sharingData.sharingInfo.expirationDate) < now());
}
//# sourceMappingURL=getExpiredSharingData.js.map